import React, {useCallback, useContext, useState} from 'react';

import clsx from 'clsx';
import {FormInput} from 'src/components/input';
import {ValidationContext} from 'src/contexts/validation-context';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';

import {smartInput, smartInputDisabled} from './smart-input.module.styl';

type Props = {
    value: string,
    onChange: (value: string) => void,
    busy?: boolean,
    disabled?: boolean,
    error?: string,
    onErrorClick?: (error: string) => void,
    maxLength?: number,
};

export const SmartInput = ({value, busy, error, disabled, onChange, onErrorClick, maxLength}: Props) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const {getErrorsByControlId} = useContext(ValidationContext);

    const onInputBlur = useCallback((newValue: string) => {
        onChange(newValue);
        setIsFocused(false);
        setIsHovered(false);
    }, [onChange]);

    const invalid = getErrorsByControlId('profile-name').length > 0;

    if (disabled) {
        return (
            <EllipsisTextHint title={value} mix={clsx([smartInput, smartInputDisabled])}>
                {value}
            </EllipsisTextHint>
        );
    }

    return isFocused || busy || invalid ? (
        <FormInput
            autofocus={isFocused}
            value={value}
            onBlur={onInputBlur}
            width={300}
            maxLength={maxLength}
            valid={error ? false : undefined}
            busy={busy}
            blurNotChanged={true}
            onWarningClick={() => (onErrorClick && error ? onErrorClick(error) : undefined)}
        />
    ) : (
        <div onClick={() => setIsFocused(true)}>
            <Group gap="xs" alignItems="center">
                <span
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    className={smartInput}>
                    <EllipsisTextHint title={value}>
                        {value}
                    </EllipsisTextHint>
                </span>
                {isHovered ? <Icon type={Icons.PENCIL} size={Sizes.Size_16}/> : null}
            </Group>
        </div>
    );
};
